var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://datastudio.google.com/embed/reporting/713f8055-f9fe-4776-aa56-cd751638fbbb/page/QkuOB","frameborder":"0","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }